import { P2 } from "../../components/Paragraph";
import ProgressBar from "./ProgressBar";
import styles from "./progressLine.module.css";

const ProgressLine = ({ topic, progress }) => {
  return (
    <div className={styles.progressLine}>
      <div
        style={{
          width: "30%",
          boxSizing: "border-box",
          flexGrow: "0",
          flexShrink: "0",
        }}
      >
        <P2
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            margin: "0",
          }}
        >
          {topic?.name}
        </P2>
      </div>
      <div
        style={{
          width: "calc(70% - var(--gap-base))",
          flexGrow: "0",
          flexShrink: "0",
        }}
      >
        <ProgressBar {...{ progress }} />
      </div>
    </div>
  );
};

export default ProgressLine;
